module.exports = __webpack_public_path__ + "assets/img/35_1122_big.5678828c.jpg";